import script from "./AppFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppFooter.vue?vue&type=script&setup=true&lang=ts"

import "./AppFooter.vue?vue&type=style&index=0&id=77b918ab&scoped=true&lang=css"

import exportComponent from "/opt/sources/madarion/mdnw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77b918ab"]])

export default __exports__